module.exports = __webpack_public_path__ + "img/5csm_Ersa-Wave-POWERFLOW-01-900x675_56d1c7c31f.38f9ba21.png";